module.exports = __webpack_public_path__ + "static/img/patent-swiper-6.a146006.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/patent-swiper-6.png
// module id = ZrZM
// module chunks = 1